class AjaxMoreInfo {
  constructor(el, opt) {
    this.el = el;
    if (document.querySelector("." + this.el)) {
      this.event();
    }
  }
  event() {
    const moreBtn = document.querySelector("." + this.el+'__btn');
    const moreArea = document.querySelector("." + this.el);
    if (moreBtn) {
      moreBtn.addEventListener('click', () => {
        const page = parseInt(moreBtn.getAttribute('data-page'), 10);
        const postNum = parseInt(moreBtn.getAttribute('data-post-num'), 10);
        const ajaxUrl = moreBtn.getAttribute('data-url');
        const tax = moreBtn.dataset.tax;
        const term = moreBtn.dataset.term;

        let fetchUrl = `${ajaxUrl}?action=load_more_posts&page=${page}&postnum=${postNum}`;

        if (tax && term) {
          fetchUrl += `&tax=${encodeURIComponent(tax)}&term=${encodeURIComponent(term)}`;
        }

        fetch(fetchUrl)
          .then(response => response.json())
          .then(data => {
            console.log(data)
            if (data.success) {
              moreArea.insertAdjacentHTML('beforeend', data.data.content);
              moreBtn.setAttribute('data-page', page + 1);

              if (!data.data.has_more) {
                moreBtn.style.display = 'none';
              }
            } else {
              console.error(data.message);
            }
          })
          .catch(error => console.error('AJAX error:', error));
    });
  }
  }
}
